import { Box, Flex } from '@chakra-ui/react';
import { ProductApprovalState } from '@texas/api/endpoints/productApprovalsApi';
import { SampleLifecycle } from './types';
import { PaIcon } from '../productApproval/PaIcon';
import { SampleState } from './SampleState';
import { compareEnum } from '@texas/utils/helpers/enumHelpers';
import { ArchivedTooltip } from '../tooltip/ArchivedTooltip';
import { defaultIconSize } from '../Icons';

interface Props {
  lifecycle: SampleLifecycle;
  paState: ProductApprovalState | undefined;
  sampleReadyDate: string | null;
  archived: string | null;
}

export function VersionCurrentState(props: Props) {
  if (props.archived) {
    return (
      <Box pr={1}>
        <ArchivedTooltip archived={props.archived} iconSize={defaultIconSize} />
      </Box>
    );
  }

  return (
    <Flex flexDir="column" gap={2} alignItems="center">
      <PaIcon state={props.paState} />
      {compareEnum(
        ProductApprovalState,
        props.paState,
        ProductApprovalState.Pending,
      ) && (
        <SampleState
          lifecycle={props.lifecycle}
          sampleReadyDate={props.sampleReadyDate}
        />
      )}
    </Flex>
  );
}
